import type { ReactElement, RefObject } from "react";
import { motion, type MotionValue } from "framer-motion";
import type { ScrollCommentData } from "@/components/ui/Cchatteaser/Cchatteaser.data";
import { SECTION_LABEL_AI, SECTION_LABEL_SOLO } from "./chatteaser3.constants";
import { CHATTEASER3_ANIM_PHASE, CHATTEASER3_CONTENT_FADE_PRESET, } from "./chatteaser3Anim";
import { ChatMessage, SectionHeader } from "./chatteaser3Messages";
import { SOLO_CARD_STYLE, SOLO_CONTENT_STYLE } from "./chatteaser3.styles";
type AnimPhaseLocal = (typeof CHATTEASER3_ANIM_PHASE)[keyof typeof CHATTEASER3_ANIM_PHASE];
type ContentFadePresetLocal = (typeof CHATTEASER3_CONTENT_FADE_PRESET)[keyof typeof CHATTEASER3_CONTENT_FADE_PRESET];
const INSTANT_TRANSITION = { duration: 0 } as const;
interface Chatteaser3SoloCardProps {
    animPhase: AnimPhaseLocal;
    contentFadePreset?: ContentFadePresetLocal;
    displayedTab: number;
    introActive: boolean;
    introSoloOpacity: number;
    solo: ScrollCommentData;
    soloContentRef?: RefObject<HTMLDivElement | null>;
    soloRef?: RefObject<HTMLDivElement | null>;
    soloScrollOpacity: MotionValue<number>;
}
export function Chatteaser3SoloCard({ animPhase, contentFadePreset = CHATTEASER3_CONTENT_FADE_PRESET.Default, displayedTab, introActive, introSoloOpacity, solo, soloContentRef, soloRef, soloScrollOpacity, }: Chatteaser3SoloCardProps): ReactElement {
    const isExit = animPhase === CHATTEASER3_ANIM_PHASE.Exit;
    const isEnter = animPhase === CHATTEASER3_ANIM_PHASE.Enter;
    const soloFade = introActive ? introSoloOpacity : isExit ? 0 : 1;
    const soloTransition = introActive
        ? INSTANT_TRANSITION
        : isExit
            ? contentFadePreset.soloFadeOutTransition
            : isEnter
                ? contentFadePreset.soloFadeInTransition
                : INSTANT_TRANSITION;
    const soloInitial: false | {
        opacity: number;
    } = !introActive && isEnter ? { opacity: 0 } : false;
    return (
      <motion.div data-el="Cchatteaser3/SoloCard/Root" ref={soloRef} style={{ ...SOLO_CARD_STYLE, opacity: soloScrollOpacity }}>
        <motion.div initial={soloInitial} animate={{ opacity: soloFade }} transition={soloTransition}>
          <div ref={soloContentRef} key={displayedTab} style={SOLO_CONTENT_STYLE}>
            <SectionHeader first={SECTION_LABEL_SOLO} second={SECTION_LABEL_AI} mintFirst={false}/>
            <ChatMessage comment={solo}/>
          </div>
        </motion.div>
      </motion.div>
    );
}
